<template>
  <div class="container swiper-container slide3">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(product,index) in newProductList" :key="index">
        <a href="" class="btn" @click.prevent="movePage(product)">
          <img :src="product.imageUrl" class="img" alt="" />
          <h2 class="item_tit">{{product.title}}</h2>
          <div class="label" v-if="product.isNew">NEW</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common';

export default {
  name: 'ListProductsSection',
  props: {
    newProductList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    movePage(product) {
      common.moveToUrlOfTargetType(this, product.linkTargetType.code, product.linkUrl);
    },
  },

};
</script>

<style></style>
